import { Button, ControlGroup, InputGroup } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

const PersonSearchForm = ({ className, onChange, value }) => {
  return (
    <ControlGroup className={className} fill>
      <InputGroup
        fill
        leftIcon="search"
        onChange={event => onChange(event.target.value)}
        placeholder="Search person by name..."
        rightElement={value ? <Button icon="cross" minimal onClick={() => onChange('')} /> : null}
        value={value}
      />
    </ControlGroup>
  );
};

PersonSearchForm.defaultProps = {
  className: undefined,
  onChange: () => {},
  value: undefined,
};

PersonSearchForm.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default PersonSearchForm;
